module.exports = __webpack_public_path__ + "img/zu22.09a579b6.png";